<template>
  <div class="message-box">
    <!--标题栏-->
    <app-header title="消息中心" @goback="goBack">
      <div slot="tips" @click="setHasRead">
        <div class="header-right">标记已读</div>
      </div>
    </app-header>
    <div class="message-filter" @click="openFilter">
      <span>{{currentType.text}}</span><i class="iconfont iconxiala"></i>
    </div>
    <pull-to :is-top-bounce="false" :is-bottom-bounce="isLoadAll" :bottom-load-method="loadmore">
      <ul class="message-list">
        <li v-for="(item, index) in messageList" :key="index">
          <div class="mes-title">{{ item.title }}</div>
          <div class="mes-content">{{ item.content }}</div>
          <div class="mes-time">{{ item.createTime }}</div>
        </li>
      </ul>
    </pull-to>
  </div>
</template>

<script>
import { commonMixin } from 'common/js/mixin';
import apis from 'api/index';
import PullTo from 'vue-pull-to';

export default {
  mixins: [commonMixin],
  components: {
    PullTo
  },
  data() {
    return {
      currentType: {}, // 当前筛选列
      typeList: [
        {value: 1, text: '未读'},
        {value: 2, text: '已读'}
      ],
      pageNumber: 1,
      pageSize: 10,
      messageList: [],
      messageTotal: 0,
    }
  },
  computed: {
    // 用来控制是否启用下拉刷新
    isLoadAll() {
      return Boolean(this.messageTotal > this.pageNumber * this.pageSize);
    },
  },
  created() {
    this.currentType = this.typeList[0];
    this.fetchMesList();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    openFilter() {
      if (!this.picker) {
        this.picker = this.$createPicker({
          title: '选择状态',
          data: [this.typeList],
          onSelect: this.changeType,
        })
      }
      this.picker.show();
    },
    // 切换模块
    changeType(value) {
      this.currentType = this.typeList.filter(item => item.value === value[0])[0];
      this.pageNumber = 1;
      this.fetchMesList('reset');
    },
    loadmore(loaded) {
      if(this.messageTotal <= this.pageNumber * this.pageSize) {
        return false;
      }
      this.pageNumber +=1;
      this.fetchMesList().then(res => {
        loaded('done');
      });
    },
    async setHasRead() {
      try {
        let params = {status: -1};
        const res = await apis.updateMessage(JSON.stringify(params));
        this.showToast('设置成功', 'success');
        this.fetchMesList('reset');
      } catch(err) {
        console.error(err);
      }
    },
    async fetchMesList(type = 'normal') {
      try {
        let params = {
          status: this.currentType.value,
          no: this.pageNumber,
          limit: this.pageSize
        };
        const res = await apis.getMessageList(params);
        this.messageTotal = res.total;
        if(type === 'reset') {
          this.messageList = res.records;
        } else {
          this.messageList = this.messageList.concat(res.records);
        }
      } catch(err) {
        console.error(err);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.message-box {
  position: relative;
  width: 100%;
  height: 100%;
  background: #fff;
  .message-filter {
    width: 100%;
    height: 50px;
    position: absolute;
    background: #F7F7F7;
    top: 44px;
    left: 0;
    text-align: center;
    line-height: 50px;
    z-index: 10;
    > span {
      font-size: 15px;
      margin-right: 5px;
    }
    > i {
      color: #979797;
    }
  }
  .message-list {
    width: 100%;
    background: #fff;
    margin-top: 95px;
    overflow: scroll;
    li {
      width: 92vw;
      min-height: 80px;
      padding: 20px 4vw;
      border-bottom: 1px solid #f0f0f0;
      .mes-title {
        font-weight: bold;
        margin-bottom: 15px;
      }
      .mes-content {
        font-size: 14px;
        color: #333;
        line-height: 20px;
        margin-bottom: 15px;
      }
      .mes-time {
        font-size: 14px;
        color: #666;
      }
    }
  }
}
</style>

